import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/39qZB9CPP1wzwcCGodrZtX/title-image-pz.png';
export function EventHero() {
  const scrollToGallery = () => {
    document.getElementById('gallery')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section aria-labelledby="event-title" className="relative flex min-h-screen w-full items-center bg-ink px-4 py-4 sm:px-6 sm:py-6 lg:px-10 lg:py-10" data-id="element-13" data-mp="22njxf2snk88j">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative mx-auto flex min-h-[calc(100vh-2rem)] w-full max-w-[1800px] overflow-hidden border border-ivory/15 bg-deep-teal sm:min-h-[calc(100vh-3rem)] lg:min-h-[calc(100vh-5rem)]" data-id="element-14" data-mp="1sx8jqoj62kog">
        <motion.img initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1.04,
        opacity: 1
      }} transition={{
        duration: 1.6,
        ease: [0.16, 1, 0.3, 1]
      }} src={HERO_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-15" data-mp="19z5z0lxnj9wg" />
        <div className="absolute inset-0 bg-ink/55" aria-hidden="true" data-id="element-16" data-mp="249y4smgm94vm" />

        <div className="relative z-10 flex w-full max-w-3xl flex-col justify-between bg-ink/35 px-6 py-8 backdrop-blur-[2px] sm:px-10 sm:py-12 lg:px-16 lg:py-14 xl:px-20 xl:py-16" data-id="element-17" data-mp="29783yttt4uwn">
          <div data-id="element-18" data-mp="30yxhcdo8gstm">
            <motion.p initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="mb-8 text-xs uppercase tracking-[0.28em] text-sage" data-id="element-19" data-mp="30zfinopr5x8e">
              Dance · Light · Music
            </motion.p>

            <motion.h1 id="event-title" initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.42
          }} className="max-w-3xl font-heading text-[clamp(3.4rem,8vw,8.5rem)] leading-[0.82] tracking-[-0.06em] text-ivory" data-id="element-20" data-mp="1biy2qh1uib6l">
              The Doors
              <br data-id="element-21" data-mp="noe1eyxb94ee" />
              <span className="italic" data-id="element-22" data-mp="nnuoxxqfj87r">of Perception</span>
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.56
          }} className="mt-10 max-w-2xl border-y border-ivory/20 py-5 text-sm uppercase tracking-[0.16em] text-ivory sm:grid sm:grid-cols-[0.75fr_1.25fr] sm:gap-6" data-id="element-23" data-mp="iq2uavyeh7zv">
              <p data-id="element-24" data-mp="4q1tthm1s2kx">27–29 August, 2026</p>
              <p className="mt-3 text-ivory/75 sm:mt-0" data-id="element-25" data-mp="3vwcp0x4dm94c">
                MONOPOL <span className="mx-1 text-sage" data-id="element-26" data-mp="3vy5yslaad9gk">|</span> Provinzstraße
                40–44, 13409 Berlin, Germany
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.68
          }} className="mt-8 max-w-2xl space-y-4 text-[15px] font-light leading-relaxed text-ivory/75 sm:text-base" data-id="element-27" data-mp="1u5rhnofkg917">
              <p data-id="element-28" data-mp="2bf3llmaudtqp">
                <span className="font-medium text-ivory" data-id="element-29" data-mp="2bek8qk01tvjj">THE DOORS OF PERCEPTION</span>{' '}
                is the first choreographic adaptation of Aldous Huxley&apos;s 1954
                book on altered reality. The 70-minute immersive work features 12
                contemporary dancers alongside volumetric visual mapping and an
                original electronic music score.
              </p>
              <p data-id="element-30" data-mp="1sm9bp6s2srtc">
                16 choreographic scenes unfold the deepest inner workings of
                Huxley&apos;s subconsciously present mind.
              </p>
              <p data-id="element-31" data-mp="341ob0h7rbvrm">
                Created by Improbable Arts in co-production with Orsolina28 Art
                Foundation.
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.84
        }} className="mt-10 flex flex-col gap-7 border-t border-ivory/20 pt-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-32" data-mp="36mchg39mmwoj">
            <p className="max-w-lg text-xl font-light leading-snug text-ivory sm:text-2xl" data-id="element-33" data-mp="3blpflk5y7q6f">
              On August 27th–29th, the doors will open.
              <span className="ml-2 text-sage" data-id="element-34" data-mp="3pk6z15otmgij">By invitation only.</span>
            </p>
            <button type="button" onClick={scrollToGallery} className="group inline-flex shrink-0 items-center gap-3 self-start text-xs uppercase tracking-[0.2em] text-ivory/65 transition-colors duration-500 hover:text-ivory focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sage sm:self-auto" aria-label="View production photographs" data-id="element-35" data-mp="3kmdu0fz97sju">
              View photographs
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-ivory/25 transition-colors duration-500 group-hover:border-sage" data-id="element-36" data-mp="qu2a0c8c05e4">
                <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="vqszfq610dc7" />
              </span>
            </button>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}